import { Component, OnInit, ViewChild } from '@angular/core';
import { Funcionalidad } from '../../_models/funcionalidad';
import { NavService } from '../../_services/_nav.service';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { Table } from 'primeng/table';
import { Router } from '@angular/router';
import { ServidorAlfresco } from '../../_models/servidor-alfresco';
import { RutasFuncionalidades } from '../../_enums/enum';
import { ServidorAlfrescoService } from '../../_services/servidor-alfresco.service';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-servidores-alfresco',
  templateUrl: './servidores-alfresco.component.html',
  styleUrls: ['./servidores-alfresco.component.css'],
})
export class ServidoresAlfrescoComponent implements OnInit {
  menu: Funcionalidad = new Funcionalidad();
  columnas: any[];
  carSerAlfresco = true;
  busqueda: any;
  servidoresAlfresco: ServidorAlfresco[] = [];
  servidoresAlfrescoSinModificar: ServidorAlfresco[] = [];
  @ViewChild('dt', { static: true }) table: Table;
  filtroBusqueda = ['fechaCreacion', 'nombre', 'ruta'];
  regPorPagina = 10;

  constructor(
    private autServicio: AutenticacionService,
    private navService: NavService,
    private router: Router,
    private conServicio: ConfirmationService,
    private servidoresAlfredosService: ServidorAlfrescoService
  ) {}

  ngOnInit() {
    const mn = this.autServicio.obtenerFuncionalidades().find((x) => x.ruta === RutasFuncionalidades.SERVIDORALFRESCO);
    if (mn) {
      this.menu = mn;
    }
    this.columnas = [
      {
        field: 'fechaCreacion',
        header: this.navService.buscarMensaje('SERVIDORALFRESCO.LBL_FECHACREACION'),
        sort: true,
      },
      { field: 'nombre', header: this.navService.buscarMensaje('SERVIDORALFRESCO.LBL_NOMBREALFRESCO'), sort: true },
      { field: 'ruta', header: this.navService.buscarMensaje('SERVIDORALFRESCO.LBL_RUTAALFRESCO'), sort: true },
      { field: 'indicadorHabilitado', header: this.navService.buscarMensaje('LBL_HABILITADO'), sort: true },
      { field: 'det', header: this.navService.buscarMensaje('LBL_ACCIONES'), sort: false },
    ];
    this.busqueda = this.navService.getSearch('servidores-alfresco.component');
    this.table.filterGlobal(this.busqueda, 'contains');

    this.servidoresAlfredosService.listado().subscribe((res) => {
      this.servidoresAlfresco = res;
      this.servidoresAlfresco.map((servidorAlfresco)=>{
        this.servidoresAlfrescoSinModificar.push(Object.assign( {} , servidorAlfresco )) ;
      });

      this.carSerAlfresco = false;
    });
  }

  /**
   * navega a la pantalla de creacion de servidor alfresco
   */
  agregar() {
    this.router.navigate([RutasFuncionalidades.SERVIDORALFRESCO + '/agregar']);
  }

  /**
   * navega a la pantalla de edicion de servidores alfresco pasa como parametro idServidorAlfresco
   * @param {ServidorAlfresco} r
   */
  editar(r: ServidorAlfresco) {
    this.router.navigate([RutasFuncionalidades.SERVIDORALFRESCO + '/actualizar/' + r.idServidorAlfresco]);
  }

  cambiarHabilitado(servidorAlfresco: ServidorAlfresco, control = null) {
    if (!servidorAlfresco.indicadorHabilitado && this.validarUnicoHabilitado(servidorAlfresco)) {
      this.conServicio.confirm({
        message: this.navService.buscarMensaje('SERVIDORALFRESCO.MSG_MINIMOUNOHABILITADO'),
        header: this.navService.buscarMensaje('LBL_CONFIRMACION'),
        icon: 'fa fa-question-circle',
        accept: () => {

        }
      });
      servidorAlfresco.indicadorHabilitado = !servidorAlfresco.indicadorHabilitado;
      control.checked = servidorAlfresco.indicadorHabilitado;
    } else {
      this.carSerAlfresco = true;
      this.servidoresAlfredosService.actualizar(servidorAlfresco).subscribe((servidorAlfresco) => {
        this.ngOnInit();
        this.navService.setMesage(2);
        this.carSerAlfresco = false;
      });
    }
  }

  validarUnicoHabilitado(servidorAlfresco: ServidorAlfresco) {
    return !!this.servidoresAlfrescoSinModificar.find((x) => x.idServidorAlfresco === servidorAlfresco.idServidorAlfresco && x.indicadorHabilitado);
  }

  /**
   * asigna valor a variable para mantener busqueda
   */
  setSearch() {
    this.navService.setSearch('servidores-alfresco.component', this.busqueda);
  }
}
